module.exports = function (e) {
  var t = {};

  function r(n) {
    if (t[n]) return t[n].exports;
    var o = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
  }

  return r.m = e, r.c = t, r.d = function (e, t, n) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (r.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      r.d(n, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return n;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 17);
}([function (e, t) {
  e.exports = function (e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  };
}, function (e, t) {
  function r(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  e.exports = function (e, t, n) {
    return t && r(e.prototype, t), n && r(e, n), e;
  };
}, function (e, t) {
  e.exports = require("react");
}, function (e, t, r) {
  e.exports = r(8);
}, function (e, t, r) {
  var n = r(9),
      o = r(10),
      i = r(11),
      a = r(13);

  e.exports = function (e, t) {
    return n(e) || o(e, t) || i(e, t) || a();
  };
}, function (e, t) {
  function r(e, t, r, n, o, i, a) {
    try {
      var s = e[i](a),
          c = s.value;
    } catch (e) {
      return void r(e);
    }

    s.done ? t(c) : Promise.resolve(c).then(n, o);
  }

  e.exports = function (e) {
    return function () {
      var t = this,
          n = arguments;
      return new Promise(function (o, i) {
        var a = e.apply(t, n);

        function s(e) {
          r(a, o, i, s, c, "next", e);
        }

        function c(e) {
          r(a, o, i, s, c, "throw", e);
        }

        s(void 0);
      });
    };
  };
}, function (module, exports, __webpack_require__) {
  (function (process, global) {
    var __WEBPACK_AMD_DEFINE_RESULT__;
    /**
     * [js-sha256]{@link https://github.com/emn178/js-sha256}
     *
     * @version 0.9.0
     * @author Chen, Yi-Cyuan [emn178@gmail.com]
     * @copyright Chen, Yi-Cyuan 2014-2017
     * @license MIT
     */


    !function () {
      "use strict";

      var ERROR = "input is invalid type",
          WINDOW = "object" == typeof window,
          root = WINDOW ? window : {};
      root.JS_SHA256_NO_WINDOW && (WINDOW = !1);
      var WEB_WORKER = !WINDOW && "object" == typeof self,
          NODE_JS = !root.JS_SHA256_NO_NODE_JS && "object" == typeof process && process.versions && process.versions.node;
      NODE_JS ? root = global : WEB_WORKER && (root = self);

      var COMMON_JS = !root.JS_SHA256_NO_COMMON_JS && "object" == typeof module && module.exports,
          AMD = __webpack_require__(16),
          ARRAY_BUFFER = !root.JS_SHA256_NO_ARRAY_BUFFER && "undefined" != typeof ArrayBuffer,
          HEX_CHARS = "0123456789abcdef".split(""),
          EXTRA = [-2147483648, 8388608, 32768, 128],
          SHIFT = [24, 16, 8, 0],
          K = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298],
          OUTPUT_TYPES = ["hex", "array", "digest", "arrayBuffer"],
          blocks = [];

      !root.JS_SHA256_NO_NODE_JS && Array.isArray || (Array.isArray = function (e) {
        return "[object Array]" === Object.prototype.toString.call(e);
      }), !ARRAY_BUFFER || !root.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW && ArrayBuffer.isView || (ArrayBuffer.isView = function (e) {
        return "object" == typeof e && e.buffer && e.buffer.constructor === ArrayBuffer;
      });

      var createOutputMethod = function createOutputMethod(e, t) {
        return function (r) {
          return new Sha256(t, !0).update(r)[e]();
        };
      },
          createMethod = function createMethod(e) {
        var t = createOutputMethod("hex", e);
        NODE_JS && (t = nodeWrap(t, e)), t.create = function () {
          return new Sha256(e);
        }, t.update = function (e) {
          return t.create().update(e);
        };

        for (var r = 0; r < OUTPUT_TYPES.length; ++r) {
          var n = OUTPUT_TYPES[r];
          t[n] = createOutputMethod(n, e);
        }

        return t;
      },
          nodeWrap = function nodeWrap(method, is224) {
        var crypto = eval("require('crypto')"),
            Buffer = eval("require('buffer').Buffer"),
            algorithm = is224 ? "sha224" : "sha256",
            nodeMethod = function nodeMethod(e) {
          if ("string" == typeof e) return crypto.createHash(algorithm).update(e, "utf8").digest("hex");
          if (null == e) throw new Error(ERROR);
          return e.constructor === ArrayBuffer && (e = new Uint8Array(e)), Array.isArray(e) || ArrayBuffer.isView(e) || e.constructor === Buffer ? crypto.createHash(algorithm).update(new Buffer(e)).digest("hex") : method(e);
        };

        return nodeMethod;
      },
          createHmacOutputMethod = function createHmacOutputMethod(e, t) {
        return function (r, n) {
          return new HmacSha256(r, t, !0).update(n)[e]();
        };
      },
          createHmacMethod = function createHmacMethod(e) {
        var t = createHmacOutputMethod("hex", e);
        t.create = function (t) {
          return new HmacSha256(t, e);
        }, t.update = function (e, r) {
          return t.create(e).update(r);
        };

        for (var r = 0; r < OUTPUT_TYPES.length; ++r) {
          var n = OUTPUT_TYPES[r];
          t[n] = createHmacOutputMethod(n, e);
        }

        return t;
      };

      function Sha256(e, t) {
        t ? (blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0, this.blocks = blocks) : this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], e ? (this.h0 = 3238371032, this.h1 = 914150663, this.h2 = 812702999, this.h3 = 4144912697, this.h4 = 4290775857, this.h5 = 1750603025, this.h6 = 1694076839, this.h7 = 3204075428) : (this.h0 = 1779033703, this.h1 = 3144134277, this.h2 = 1013904242, this.h3 = 2773480762, this.h4 = 1359893119, this.h5 = 2600822924, this.h6 = 528734635, this.h7 = 1541459225), this.block = this.start = this.bytes = this.hBytes = 0, this.finalized = this.hashed = !1, this.first = !0, this.is224 = e;
      }

      function HmacSha256(e, t, r) {
        var n,
            o = typeof e;

        if ("string" === o) {
          var i,
              a = [],
              s = e.length,
              c = 0;

          for (n = 0; n < s; ++n) {
            (i = e.charCodeAt(n)) < 128 ? a[c++] = i : i < 2048 ? (a[c++] = 192 | i >> 6, a[c++] = 128 | 63 & i) : i < 55296 || i >= 57344 ? (a[c++] = 224 | i >> 12, a[c++] = 128 | i >> 6 & 63, a[c++] = 128 | 63 & i) : (i = 65536 + ((1023 & i) << 10 | 1023 & e.charCodeAt(++n)), a[c++] = 240 | i >> 18, a[c++] = 128 | i >> 12 & 63, a[c++] = 128 | i >> 6 & 63, a[c++] = 128 | 63 & i);
          }

          e = a;
        } else {
          if ("object" !== o) throw new Error(ERROR);
          if (null === e) throw new Error(ERROR);
          if (ARRAY_BUFFER && e.constructor === ArrayBuffer) e = new Uint8Array(e);else if (!(Array.isArray(e) || ARRAY_BUFFER && ArrayBuffer.isView(e))) throw new Error(ERROR);
        }

        e.length > 64 && (e = new Sha256(t, !0).update(e).array());
        var u = [],
            h = [];

        for (n = 0; n < 64; ++n) {
          var l = e[n] || 0;
          u[n] = 92 ^ l, h[n] = 54 ^ l;
        }

        Sha256.call(this, t, r), this.update(h), this.oKeyPad = u, this.inner = !0, this.sharedMemory = r;
      }

      Sha256.prototype.update = function (e) {
        if (!this.finalized) {
          var t,
              r = typeof e;

          if ("string" !== r) {
            if ("object" !== r) throw new Error(ERROR);
            if (null === e) throw new Error(ERROR);
            if (ARRAY_BUFFER && e.constructor === ArrayBuffer) e = new Uint8Array(e);else if (!(Array.isArray(e) || ARRAY_BUFFER && ArrayBuffer.isView(e))) throw new Error(ERROR);
            t = !0;
          }

          for (var n, o, i = 0, a = e.length, s = this.blocks; i < a;) {
            if (this.hashed && (this.hashed = !1, s[0] = this.block, s[16] = s[1] = s[2] = s[3] = s[4] = s[5] = s[6] = s[7] = s[8] = s[9] = s[10] = s[11] = s[12] = s[13] = s[14] = s[15] = 0), t) for (o = this.start; i < a && o < 64; ++i) {
              s[o >> 2] |= e[i] << SHIFT[3 & o++];
            } else for (o = this.start; i < a && o < 64; ++i) {
              (n = e.charCodeAt(i)) < 128 ? s[o >> 2] |= n << SHIFT[3 & o++] : n < 2048 ? (s[o >> 2] |= (192 | n >> 6) << SHIFT[3 & o++], s[o >> 2] |= (128 | 63 & n) << SHIFT[3 & o++]) : n < 55296 || n >= 57344 ? (s[o >> 2] |= (224 | n >> 12) << SHIFT[3 & o++], s[o >> 2] |= (128 | n >> 6 & 63) << SHIFT[3 & o++], s[o >> 2] |= (128 | 63 & n) << SHIFT[3 & o++]) : (n = 65536 + ((1023 & n) << 10 | 1023 & e.charCodeAt(++i)), s[o >> 2] |= (240 | n >> 18) << SHIFT[3 & o++], s[o >> 2] |= (128 | n >> 12 & 63) << SHIFT[3 & o++], s[o >> 2] |= (128 | n >> 6 & 63) << SHIFT[3 & o++], s[o >> 2] |= (128 | 63 & n) << SHIFT[3 & o++]);
            }
            this.lastByteIndex = o, this.bytes += o - this.start, o >= 64 ? (this.block = s[16], this.start = o - 64, this.hash(), this.hashed = !0) : this.start = o;
          }

          return this.bytes > 4294967295 && (this.hBytes += this.bytes / 4294967296 << 0, this.bytes = this.bytes % 4294967296), this;
        }
      }, Sha256.prototype.finalize = function () {
        if (!this.finalized) {
          this.finalized = !0;
          var e = this.blocks,
              t = this.lastByteIndex;
          e[16] = this.block, e[t >> 2] |= EXTRA[3 & t], this.block = e[16], t >= 56 && (this.hashed || this.hash(), e[0] = this.block, e[16] = e[1] = e[2] = e[3] = e[4] = e[5] = e[6] = e[7] = e[8] = e[9] = e[10] = e[11] = e[12] = e[13] = e[14] = e[15] = 0), e[14] = this.hBytes << 3 | this.bytes >>> 29, e[15] = this.bytes << 3, this.hash();
        }
      }, Sha256.prototype.hash = function () {
        var e,
            t,
            r,
            n,
            o,
            i,
            a,
            s,
            c,
            u = this.h0,
            h = this.h1,
            l = this.h2,
            f = this.h3,
            d = this.h4,
            p = this.h5,
            y = this.h6,
            v = this.h7,
            m = this.blocks;

        for (e = 16; e < 64; ++e) {
          t = ((o = m[e - 15]) >>> 7 | o << 25) ^ (o >>> 18 | o << 14) ^ o >>> 3, r = ((o = m[e - 2]) >>> 17 | o << 15) ^ (o >>> 19 | o << 13) ^ o >>> 10, m[e] = m[e - 16] + t + m[e - 7] + r << 0;
        }

        for (c = h & l, e = 0; e < 64; e += 4) {
          this.first ? (this.is224 ? (i = 300032, v = (o = m[0] - 1413257819) - 150054599 << 0, f = o + 24177077 << 0) : (i = 704751109, v = (o = m[0] - 210244248) - 1521486534 << 0, f = o + 143694565 << 0), this.first = !1) : (t = (u >>> 2 | u << 30) ^ (u >>> 13 | u << 19) ^ (u >>> 22 | u << 10), n = (i = u & h) ^ u & l ^ c, v = f + (o = v + (r = (d >>> 6 | d << 26) ^ (d >>> 11 | d << 21) ^ (d >>> 25 | d << 7)) + (d & p ^ ~d & y) + K[e] + m[e]) << 0, f = o + (t + n) << 0), t = (f >>> 2 | f << 30) ^ (f >>> 13 | f << 19) ^ (f >>> 22 | f << 10), n = (a = f & u) ^ f & h ^ i, y = l + (o = y + (r = (v >>> 6 | v << 26) ^ (v >>> 11 | v << 21) ^ (v >>> 25 | v << 7)) + (v & d ^ ~v & p) + K[e + 1] + m[e + 1]) << 0, t = ((l = o + (t + n) << 0) >>> 2 | l << 30) ^ (l >>> 13 | l << 19) ^ (l >>> 22 | l << 10), n = (s = l & f) ^ l & u ^ a, p = h + (o = p + (r = (y >>> 6 | y << 26) ^ (y >>> 11 | y << 21) ^ (y >>> 25 | y << 7)) + (y & v ^ ~y & d) + K[e + 2] + m[e + 2]) << 0, t = ((h = o + (t + n) << 0) >>> 2 | h << 30) ^ (h >>> 13 | h << 19) ^ (h >>> 22 | h << 10), n = (c = h & l) ^ h & f ^ s, d = u + (o = d + (r = (p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) + (p & y ^ ~p & v) + K[e + 3] + m[e + 3]) << 0, u = o + (t + n) << 0;
        }

        this.h0 = this.h0 + u << 0, this.h1 = this.h1 + h << 0, this.h2 = this.h2 + l << 0, this.h3 = this.h3 + f << 0, this.h4 = this.h4 + d << 0, this.h5 = this.h5 + p << 0, this.h6 = this.h6 + y << 0, this.h7 = this.h7 + v << 0;
      }, Sha256.prototype.hex = function () {
        this.finalize();
        var e = this.h0,
            t = this.h1,
            r = this.h2,
            n = this.h3,
            o = this.h4,
            i = this.h5,
            a = this.h6,
            s = this.h7,
            c = HEX_CHARS[e >> 28 & 15] + HEX_CHARS[e >> 24 & 15] + HEX_CHARS[e >> 20 & 15] + HEX_CHARS[e >> 16 & 15] + HEX_CHARS[e >> 12 & 15] + HEX_CHARS[e >> 8 & 15] + HEX_CHARS[e >> 4 & 15] + HEX_CHARS[15 & e] + HEX_CHARS[t >> 28 & 15] + HEX_CHARS[t >> 24 & 15] + HEX_CHARS[t >> 20 & 15] + HEX_CHARS[t >> 16 & 15] + HEX_CHARS[t >> 12 & 15] + HEX_CHARS[t >> 8 & 15] + HEX_CHARS[t >> 4 & 15] + HEX_CHARS[15 & t] + HEX_CHARS[r >> 28 & 15] + HEX_CHARS[r >> 24 & 15] + HEX_CHARS[r >> 20 & 15] + HEX_CHARS[r >> 16 & 15] + HEX_CHARS[r >> 12 & 15] + HEX_CHARS[r >> 8 & 15] + HEX_CHARS[r >> 4 & 15] + HEX_CHARS[15 & r] + HEX_CHARS[n >> 28 & 15] + HEX_CHARS[n >> 24 & 15] + HEX_CHARS[n >> 20 & 15] + HEX_CHARS[n >> 16 & 15] + HEX_CHARS[n >> 12 & 15] + HEX_CHARS[n >> 8 & 15] + HEX_CHARS[n >> 4 & 15] + HEX_CHARS[15 & n] + HEX_CHARS[o >> 28 & 15] + HEX_CHARS[o >> 24 & 15] + HEX_CHARS[o >> 20 & 15] + HEX_CHARS[o >> 16 & 15] + HEX_CHARS[o >> 12 & 15] + HEX_CHARS[o >> 8 & 15] + HEX_CHARS[o >> 4 & 15] + HEX_CHARS[15 & o] + HEX_CHARS[i >> 28 & 15] + HEX_CHARS[i >> 24 & 15] + HEX_CHARS[i >> 20 & 15] + HEX_CHARS[i >> 16 & 15] + HEX_CHARS[i >> 12 & 15] + HEX_CHARS[i >> 8 & 15] + HEX_CHARS[i >> 4 & 15] + HEX_CHARS[15 & i] + HEX_CHARS[a >> 28 & 15] + HEX_CHARS[a >> 24 & 15] + HEX_CHARS[a >> 20 & 15] + HEX_CHARS[a >> 16 & 15] + HEX_CHARS[a >> 12 & 15] + HEX_CHARS[a >> 8 & 15] + HEX_CHARS[a >> 4 & 15] + HEX_CHARS[15 & a];
        return this.is224 || (c += HEX_CHARS[s >> 28 & 15] + HEX_CHARS[s >> 24 & 15] + HEX_CHARS[s >> 20 & 15] + HEX_CHARS[s >> 16 & 15] + HEX_CHARS[s >> 12 & 15] + HEX_CHARS[s >> 8 & 15] + HEX_CHARS[s >> 4 & 15] + HEX_CHARS[15 & s]), c;
      }, Sha256.prototype.toString = Sha256.prototype.hex, Sha256.prototype.digest = function () {
        this.finalize();
        var e = this.h0,
            t = this.h1,
            r = this.h2,
            n = this.h3,
            o = this.h4,
            i = this.h5,
            a = this.h6,
            s = this.h7,
            c = [e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, 255 & e, t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, 255 & t, r >> 24 & 255, r >> 16 & 255, r >> 8 & 255, 255 & r, n >> 24 & 255, n >> 16 & 255, n >> 8 & 255, 255 & n, o >> 24 & 255, o >> 16 & 255, o >> 8 & 255, 255 & o, i >> 24 & 255, i >> 16 & 255, i >> 8 & 255, 255 & i, a >> 24 & 255, a >> 16 & 255, a >> 8 & 255, 255 & a];
        return this.is224 || c.push(s >> 24 & 255, s >> 16 & 255, s >> 8 & 255, 255 & s), c;
      }, Sha256.prototype.array = Sha256.prototype.digest, Sha256.prototype.arrayBuffer = function () {
        this.finalize();
        var e = new ArrayBuffer(this.is224 ? 28 : 32),
            t = new DataView(e);
        return t.setUint32(0, this.h0), t.setUint32(4, this.h1), t.setUint32(8, this.h2), t.setUint32(12, this.h3), t.setUint32(16, this.h4), t.setUint32(20, this.h5), t.setUint32(24, this.h6), this.is224 || t.setUint32(28, this.h7), e;
      }, HmacSha256.prototype = new Sha256(), HmacSha256.prototype.finalize = function () {
        if (Sha256.prototype.finalize.call(this), this.inner) {
          this.inner = !1;
          var e = this.array();
          Sha256.call(this, this.is224, this.sharedMemory), this.update(this.oKeyPad), this.update(e), Sha256.prototype.finalize.call(this);
        }
      };
      var exports = createMethod();
      exports.sha256 = exports, exports.sha224 = createMethod(!0), exports.sha256.hmac = createHmacMethod(), exports.sha224.hmac = createHmacMethod(!0), COMMON_JS ? module.exports = exports : (root.sha256 = exports.sha256, root.sha224 = exports.sha224, AMD && (__WEBPACK_AMD_DEFINE_RESULT__ = function () {
        return exports;
      }.call(exports, __webpack_require__, exports, module), void 0 === __WEBPACK_AMD_DEFINE_RESULT__ || (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)));
    }();
  }).call(this, __webpack_require__(14), __webpack_require__(15));
}, function (e, t, r) {
  "use strict";

  t.byteLength = function (e) {
    var t = u(e),
        r = t[0],
        n = t[1];
    return 3 * (r + n) / 4 - n;
  }, t.toByteArray = function (e) {
    var t,
        r,
        n = u(e),
        a = n[0],
        s = n[1],
        c = new i(function (e, t, r) {
      return 3 * (t + r) / 4 - r;
    }(0, a, s)),
        h = 0,
        l = s > 0 ? a - 4 : a;

    for (r = 0; r < l; r += 4) {
      t = o[e.charCodeAt(r)] << 18 | o[e.charCodeAt(r + 1)] << 12 | o[e.charCodeAt(r + 2)] << 6 | o[e.charCodeAt(r + 3)], c[h++] = t >> 16 & 255, c[h++] = t >> 8 & 255, c[h++] = 255 & t;
    }

    2 === s && (t = o[e.charCodeAt(r)] << 2 | o[e.charCodeAt(r + 1)] >> 4, c[h++] = 255 & t);
    1 === s && (t = o[e.charCodeAt(r)] << 10 | o[e.charCodeAt(r + 1)] << 4 | o[e.charCodeAt(r + 2)] >> 2, c[h++] = t >> 8 & 255, c[h++] = 255 & t);
    return c;
  }, t.fromByteArray = function (e) {
    for (var t, r = e.length, o = r % 3, i = [], a = 0, s = r - o; a < s; a += 16383) {
      i.push(h(e, a, a + 16383 > s ? s : a + 16383));
    }

    1 === o ? (t = e[r - 1], i.push(n[t >> 2] + n[t << 4 & 63] + "==")) : 2 === o && (t = (e[r - 2] << 8) + e[r - 1], i.push(n[t >> 10] + n[t >> 4 & 63] + n[t << 2 & 63] + "="));
    return i.join("");
  };

  for (var n = [], o = [], i = "undefined" != typeof Uint8Array ? Uint8Array : Array, a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", s = 0, c = a.length; s < c; ++s) {
    n[s] = a[s], o[a.charCodeAt(s)] = s;
  }

  function u(e) {
    var t = e.length;
    if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    var r = e.indexOf("=");
    return -1 === r && (r = t), [r, r === t ? 0 : 4 - r % 4];
  }

  function h(e, t, r) {
    for (var o, i, a = [], s = t; s < r; s += 3) {
      o = (e[s] << 16 & 16711680) + (e[s + 1] << 8 & 65280) + (255 & e[s + 2]), a.push(n[(i = o) >> 18 & 63] + n[i >> 12 & 63] + n[i >> 6 & 63] + n[63 & i]);
    }

    return a.join("");
  }

  o["-".charCodeAt(0)] = 62, o["_".charCodeAt(0)] = 63;
}, function (e, t, r) {
  var n = function (e) {
    "use strict";

    var t = Object.prototype,
        r = t.hasOwnProperty,
        n = "function" == typeof Symbol ? Symbol : {},
        o = n.iterator || "@@iterator",
        i = n.asyncIterator || "@@asyncIterator",
        a = n.toStringTag || "@@toStringTag";

    function s(e, t, r, n) {
      var o = t && t.prototype instanceof h ? t : h,
          i = Object.create(o.prototype),
          a = new w(n || []);
      return i._invoke = function (e, t, r) {
        var n = "suspendedStart";
        return function (o, i) {
          if ("executing" === n) throw new Error("Generator is already running");

          if ("completed" === n) {
            if ("throw" === o) throw i;
            return E();
          }

          for (r.method = o, r.arg = i;;) {
            var a = r.delegate;

            if (a) {
              var s = k(a, r);

              if (s) {
                if (s === u) continue;
                return s;
              }
            }

            if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
              if ("suspendedStart" === n) throw n = "completed", r.arg;
              r.dispatchException(r.arg);
            } else "return" === r.method && r.abrupt("return", r.arg);
            n = "executing";
            var h = c(e, t, r);

            if ("normal" === h.type) {
              if (n = r.done ? "completed" : "suspendedYield", h.arg === u) continue;
              return {
                value: h.arg,
                done: r.done
              };
            }

            "throw" === h.type && (n = "completed", r.method = "throw", r.arg = h.arg);
          }
        };
      }(e, r, a), i;
    }

    function c(e, t, r) {
      try {
        return {
          type: "normal",
          arg: e.call(t, r)
        };
      } catch (e) {
        return {
          type: "throw",
          arg: e
        };
      }
    }

    e.wrap = s;
    var u = {};

    function h() {}

    function l() {}

    function f() {}

    var d = {};

    d[o] = function () {
      return this;
    };

    var p = Object.getPrototypeOf,
        y = p && p(p(A([])));
    y && y !== t && r.call(y, o) && (d = y);
    var v = f.prototype = h.prototype = Object.create(d);

    function m(e) {
      ["next", "throw", "return"].forEach(function (t) {
        e[t] = function (e) {
          return this._invoke(t, e);
        };
      });
    }

    function g(e, t) {
      var n;

      this._invoke = function (o, i) {
        function a() {
          return new t(function (n, a) {
            !function n(o, i, a, s) {
              var u = c(e[o], e, i);

              if ("throw" !== u.type) {
                var h = u.arg,
                    l = h.value;
                return l && "object" == typeof l && r.call(l, "__await") ? t.resolve(l.__await).then(function (e) {
                  n("next", e, a, s);
                }, function (e) {
                  n("throw", e, a, s);
                }) : t.resolve(l).then(function (e) {
                  h.value = e, a(h);
                }, function (e) {
                  return n("throw", e, a, s);
                });
              }

              s(u.arg);
            }(o, i, n, a);
          });
        }

        return n = n ? n.then(a, a) : a();
      };
    }

    function k(e, t) {
      var r = e.iterator[t.method];

      if (void 0 === r) {
        if (t.delegate = null, "throw" === t.method) {
          if (e.iterator.return && (t.method = "return", t.arg = void 0, k(e, t), "throw" === t.method)) return u;
          t.method = "throw", t.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return u;
      }

      var n = c(r, e.iterator, t.arg);
      if ("throw" === n.type) return t.method = "throw", t.arg = n.arg, t.delegate = null, u;
      var o = n.arg;
      return o ? o.done ? (t[e.resultName] = o.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, u) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, u);
    }

    function S(e) {
      var t = {
        tryLoc: e[0]
      };
      1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
    }

    function _(e) {
      var t = e.completion || {};
      t.type = "normal", delete t.arg, e.completion = t;
    }

    function w(e) {
      this.tryEntries = [{
        tryLoc: "root"
      }], e.forEach(S, this), this.reset(!0);
    }

    function A(e) {
      if (e) {
        var t = e[o];
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;

        if (!isNaN(e.length)) {
          var n = -1,
              i = function t() {
            for (; ++n < e.length;) {
              if (r.call(e, n)) return t.value = e[n], t.done = !1, t;
            }

            return t.value = void 0, t.done = !0, t;
          };

          return i.next = i;
        }
      }

      return {
        next: E
      };
    }

    function E() {
      return {
        value: void 0,
        done: !0
      };
    }

    return l.prototype = v.constructor = f, f.constructor = l, f[a] = l.displayName = "GeneratorFunction", e.isGeneratorFunction = function (e) {
      var t = "function" == typeof e && e.constructor;
      return !!t && (t === l || "GeneratorFunction" === (t.displayName || t.name));
    }, e.mark = function (e) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(e, f) : (e.__proto__ = f, a in e || (e[a] = "GeneratorFunction")), e.prototype = Object.create(v), e;
    }, e.awrap = function (e) {
      return {
        __await: e
      };
    }, m(g.prototype), g.prototype[i] = function () {
      return this;
    }, e.AsyncIterator = g, e.async = function (t, r, n, o, i) {
      void 0 === i && (i = Promise);
      var a = new g(s(t, r, n, o), i);
      return e.isGeneratorFunction(r) ? a : a.next().then(function (e) {
        return e.done ? e.value : a.next();
      });
    }, m(v), v[a] = "Generator", v[o] = function () {
      return this;
    }, v.toString = function () {
      return "[object Generator]";
    }, e.keys = function (e) {
      var t = [];

      for (var r in e) {
        t.push(r);
      }

      return t.reverse(), function r() {
        for (; t.length;) {
          var n = t.pop();
          if (n in e) return r.value = n, r.done = !1, r;
        }

        return r.done = !0, r;
      };
    }, e.values = A, w.prototype = {
      constructor: w,
      reset: function reset(e) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(_), !e) for (var t in this) {
          "t" === t.charAt(0) && r.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
        }
      },
      stop: function stop() {
        this.done = !0;
        var e = this.tryEntries[0].completion;
        if ("throw" === e.type) throw e.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(e) {
        if (this.done) throw e;
        var t = this;

        function n(r, n) {
          return a.type = "throw", a.arg = e, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
        }

        for (var o = this.tryEntries.length - 1; o >= 0; --o) {
          var i = this.tryEntries[o],
              a = i.completion;
          if ("root" === i.tryLoc) return n("end");

          if (i.tryLoc <= this.prev) {
            var s = r.call(i, "catchLoc"),
                c = r.call(i, "finallyLoc");

            if (s && c) {
              if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
              if (this.prev < i.finallyLoc) return n(i.finallyLoc);
            } else if (s) {
              if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
            } else {
              if (!c) throw new Error("try statement without catch or finally");
              if (this.prev < i.finallyLoc) return n(i.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(e, t) {
        for (var n = this.tryEntries.length - 1; n >= 0; --n) {
          var o = this.tryEntries[n];

          if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
            var i = o;
            break;
          }
        }

        i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
        var a = i ? i.completion : {};
        return a.type = e, a.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, u) : this.complete(a);
      },
      complete: function complete(e, t) {
        if ("throw" === e.type) throw e.arg;
        return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), u;
      },
      finish: function finish(e) {
        for (var t = this.tryEntries.length - 1; t >= 0; --t) {
          var r = this.tryEntries[t];
          if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), _(r), u;
        }
      },
      catch: function _catch(e) {
        for (var t = this.tryEntries.length - 1; t >= 0; --t) {
          var r = this.tryEntries[t];

          if (r.tryLoc === e) {
            var n = r.completion;

            if ("throw" === n.type) {
              var o = n.arg;

              _(r);
            }

            return o;
          }
        }

        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(e, t, r) {
        return this.delegate = {
          iterator: A(e),
          resultName: t,
          nextLoc: r
        }, "next" === this.method && (this.arg = void 0), u;
      }
    }, e;
  }(e.exports);

  try {
    regeneratorRuntime = n;
  } catch (e) {
    Function("r", "regeneratorRuntime = r")(n);
  }
}, function (e, t) {
  e.exports = function (e) {
    if (Array.isArray(e)) return e;
  };
}, function (e, t) {
  e.exports = function (e, t) {
    if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
      var r = [],
          n = !0,
          o = !1,
          i = void 0;

      try {
        for (var a, s = e[Symbol.iterator](); !(n = (a = s.next()).done) && (r.push(a.value), !t || r.length !== t); n = !0) {
          ;
        }
      } catch (e) {
        o = !0, i = e;
      } finally {
        try {
          n || null == s.return || s.return();
        } finally {
          if (o) throw i;
        }
      }

      return r;
    }
  };
}, function (e, t, r) {
  var n = r(12);

  e.exports = function (e, t) {
    if (e) {
      if ("string" == typeof e) return n(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? n(e, t) : void 0;
    }
  };
}, function (e, t) {
  e.exports = function (e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var r = 0, n = new Array(t); r < t; r++) {
      n[r] = e[r];
    }

    return n;
  };
}, function (e, t) {
  e.exports = function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  };
}, function (e, t) {
  var r,
      n,
      o = e.exports = {};

  function i() {
    throw new Error("setTimeout has not been defined");
  }

  function a() {
    throw new Error("clearTimeout has not been defined");
  }

  function s(e) {
    if (r === setTimeout) return setTimeout(e, 0);
    if ((r === i || !r) && setTimeout) return r = setTimeout, setTimeout(e, 0);

    try {
      return r(e, 0);
    } catch (t) {
      try {
        return r.call(null, e, 0);
      } catch (t) {
        return r.call(this, e, 0);
      }
    }
  }

  !function () {
    try {
      r = "function" == typeof setTimeout ? setTimeout : i;
    } catch (e) {
      r = i;
    }

    try {
      n = "function" == typeof clearTimeout ? clearTimeout : a;
    } catch (e) {
      n = a;
    }
  }();
  var c,
      u = [],
      h = !1,
      l = -1;

  function f() {
    h && c && (h = !1, c.length ? u = c.concat(u) : l = -1, u.length && d());
  }

  function d() {
    if (!h) {
      var e = s(f);
      h = !0;

      for (var t = u.length; t;) {
        for (c = u, u = []; ++l < t;) {
          c && c[l].run();
        }

        l = -1, t = u.length;
      }

      c = null, h = !1, function (e) {
        if (n === clearTimeout) return clearTimeout(e);
        if ((n === a || !n) && clearTimeout) return n = clearTimeout, clearTimeout(e);

        try {
          n(e);
        } catch (t) {
          try {
            return n.call(null, e);
          } catch (t) {
            return n.call(this, e);
          }
        }
      }(e);
    }
  }

  function p(e, t) {
    this.fun = e, this.array = t;
  }

  function y() {}

  o.nextTick = function (e) {
    var t = new Array(arguments.length - 1);
    if (arguments.length > 1) for (var r = 1; r < arguments.length; r++) {
      t[r - 1] = arguments[r];
    }
    u.push(new p(e, t)), 1 !== u.length || h || s(d);
  }, p.prototype.run = function () {
    this.fun.apply(null, this.array);
  }, o.title = "browser", o.browser = !0, o.env = {}, o.argv = [], o.version = "", o.versions = {}, o.on = y, o.addListener = y, o.once = y, o.off = y, o.removeListener = y, o.removeAllListeners = y, o.emit = y, o.prependListener = y, o.prependOnceListener = y, o.listeners = function (e) {
    return [];
  }, o.binding = function (e) {
    throw new Error("process.binding is not supported");
  }, o.cwd = function () {
    return "/";
  }, o.chdir = function (e) {
    throw new Error("process.chdir is not supported");
  }, o.umask = function () {
    return 0;
  };
}, function (e, t) {
  var r;

  r = function () {
    return this;
  }();

  try {
    r = r || new Function("return this")();
  } catch (e) {
    "object" == typeof window && (r = window);
  }

  e.exports = r;
}, function (e, t) {
  (function (t) {
    e.exports = t;
  }).call(this, {});
}, function (e, t, r) {
  "use strict";

  r.r(t), r.d(t, "useKeycloak", function () {
    return T;
  });

  var n = r(3),
      o = r.n(n),
      i = r(5),
      a = r.n(i),
      s = r(4),
      c = r.n(s),
      u = r(2),
      h = r(0),
      l = r.n(h),
      f = r(1),
      d = r.n(f),
      p = function p(e, t) {
    for (var r = function (e) {
      var t,
          r = window.crypto || window.msCrypto;
      if (r && r.getRandomValues && window.Uint8Array) return t = new Uint8Array(e), r.getRandomValues(t), t;
      t = new Array(e);

      for (var n = 0; n < t.length; n += 1) {
        t[n] = Math.floor(256 * Math.random());
      }

      return t;
    }(e), n = new Array(e), o = 0; o < e; o += 1) {
      n[o] = t.charCodeAt(r[o] % t.length);
    }

    return String.fromCharCode.apply(null, n);
  },
      y = function y() {
    var e = p(36, "0123456789abcdef").split("");
    return e[14] = "4", e[19] = "0123456789abcdef".substr(3 & e[19] | 8, 1), e[8] = "-", e[13] = "-", e[18] = "-", e[23] = "-", e.join("");
  },
      v = function v() {
    for (var e = new Date().getTime(), t = 0; t < localStorage.length; t += 1) {
      var r = localStorage.key(t);

      if (r && -1 !== r.indexOf("kc-callback-")) {
        var n = localStorage.getItem(r);
        if (n) try {
          var o = JSON.parse(n).expires;
          (!o || o < e) && localStorage.removeItem(r);
        } catch (e) {
          localStorage.removeItem(r);
        }
      }
    }
  },
      m = !1;

  function g() {
    m || (m = !0, console.warn("[KEYCLOAK] Usage of legacy style promise methods such as `.error()` and `.success()` has been deprecated and support will be removed in future versions. Use standard style promise methods such as `.then() and `.catch()` instead."));
  }

  function k(e) {
    return e.__proto__ = S.prototype, e;
  }

  function S(e) {
    return k(new Promise(e));
  }

  function _() {
    var e = {
      setSuccess: function setSuccess(t) {
        e.resolve(t);
      },
      setError: function setError(t) {
        e.reject(t);
      }
    };
    return e.promise = new S(function (t, r) {
      e.resolve = t, e.reject = r;
    }), e;
  }

  S.prototype = Object.create(Promise.prototype), S.prototype.constructor = S, S.prototype.success = function (e) {
    return g(), k(this.then(function (t) {
      e(t);
    }));
  }, S.prototype.error = function (e) {
    return g(), k(this.catch(function (t) {
      e(t);
    }));
  };

  var w = function () {
    function e() {
      l()(this, e), localStorage.setItem("kc-test", "test"), localStorage.removeItem("kc-test"), this.ls = localStorage;
    }

    return d()(e, [{
      key: "get",
      value: function value(e) {
        if (!e) return null;
        var t = "kc-callback-".concat(e),
            r = this.ls.getItem(t);
        return r && (this.ls.removeItem(t), r = JSON.parse(r)), v(), r;
      }
    }, {
      key: "add",
      value: function value(e) {
        v();
        var t = "kc-callback-".concat(e.state),
            r = Object.assign(Object.assign({}, e), {
          expires: new Date().getTime() + 36e5
        });
        this.ls.setItem(t, JSON.stringify(r));
      }
    }]), e;
  }(),
      A = function () {
    function e() {
      var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      l()(this, e), this.useDangerCookies = t;
    }

    return d()(e, [{
      key: "get",
      value: function value(e) {
        if (!e) return null;
        var t = this.getCookie("kc-callback-".concat(e));
        return this.setCookie("kc-callback-".concat(e), "", this.cookieExpiration(-100)), t ? JSON.parse(t) : null;
      }
    }, {
      key: "add",
      value: function value(e) {
        this.setCookie("kc-callback-".concat(e.state), JSON.stringify(e), this.cookieExpiration(60));
      }
    }, {
      key: "removeItem",
      value: function value(e) {
        this.setCookie(e, "", this.cookieExpiration(-100));
      }
    }, {
      key: "cookieExpiration",
      value: function value(e) {
        var t = new Date();
        return t.setTime(t.getTime() + 60 * e * 1e3), t;
      }
    }, {
      key: "getCookie",
      value: function value(e) {
        for (var t = "".concat(e, "="), r = document.cookie.split(";"), n = 0; n < r.length; n += 1) {
          for (var o = r[n]; " " === o.charAt(0);) {
            o = o.substring(1);
          }

          if (-1 !== o.indexOf(t)) return o.substring(t.length, o.length);
        }

        return "";
      }
    }, {
      key: "setCookie",
      value: function value(e, t, r) {
        var n = "".concat(e, "=").concat(t, "; expires=").concat(r.toUTCString(), "; ");
        document.cookie = n;
      }
    }, {
      key: "addSecureCookie",
      value: function value(e, t) {
        this.setSecureCookie(e, t, this.cookieExpiration(2880));
      }
    }, {
      key: "setSecureCookie",
      value: function value(e, t, r) {
        var n = "".concat(e, "=").concat(t, "; expires=").concat(r.toUTCString(), "; ").concat(this.useDangerCookies ? "" : "secure; ", "path=/; ");
        document.cookie = n;
      }
    }]), e;
  }(),
      E = function E(e) {
    var t = e.split(".")[1];

    switch ((t = (t = t.replace("/-/g", "+")).replace("/_/g", "/")).length % 4) {
      case 0:
        break;

      case 2:
        t += "==";
        break;

      case 3:
        t += "=";
        break;

      default:
        throw Error("Invalid token");
    }

    return t = (t = "".concat(t, "===").slice(0, t.length + t.length % 4)).replace(/-/g, "+").replace(/_/g, "/"), t = decodeURIComponent(escape(atob(t))), t = JSON.parse(t);
  },
      R = r(6),
      H = r(7),
      b = r.n(H),
      C = function () {
    function e(t) {
      var r = this;
      l()(this, e), this.loadAdapter = function () {
        var e = r.keycloak;
        r.adapter = {
          login: function login(t) {
            return window.location.replace(e.createLoginUrl(t)), _().promise;
          },
          logout: function logout(t) {
            return window.location.replace(e.createLogoutUrl(t)), _().promise;
          },
          register: function register(t) {
            return window.location.replace(e.createRegisterUrl(t)), _().promise;
          },
          accountManagement: function accountManagement() {
            var t = e.createAccountUrl();
            if (void 0 === t) throw Error("Not supported by the OIDC server");
            return window.location.href = t, _().promise;
          },
          redirectUri: function redirectUri(t) {
            return t && t.redirectUri ? t.redirectUri : e.redirectUri ? e.redirectUri : window.location.href;
          }
        };
      }, this.keycloak = this, this.config = t, this.refreshQueue = [], this.useNonce = void 0 === t.useNonce || t.useNonce, this.authenticated = !1, this.loginRequired = !1, this.responseMode = "fragment", this.responseType = "code", this.flow = "standard", this.scope = t.scope || "", this.pkceMethod = "S256", this.timeSkew = 0, this.redirectUri = "", this.realm = "", this.clientId = "", this.cookieStorage = new A(t.useDangerCookies || !1);
    }

    return d()(e, [{
      key: "init",
      value: function value(e) {
        var t = this;
        this.authenticated = !1, this.callbackStorage = function () {
          try {
            return new w();
          } catch (e) {}

          return new A();
        }(), this.loadAdapter(), this.initOptions = e, this.loginRequired = "login-required" === e.onLoad || this.loginRequired, this.timeSkew = e.timeSkew || this.timeSkew, this.redirectUri = e.redirectUri || this.redirectUri;

        var r = _(),
            n = _();

        n.promise.then(function () {
          t.onReady && t.onReady(t.authenticated), r.setSuccess(t.authenticated);
        }).catch(function (e) {
          r.setError(e);
        });
        var o = this.loadConfig();
        return o.then(function () {
          var r = t.parseCallback(window.location.href);

          if (r && window.history.replaceState(window.history.state, "", r.newUrl), r && r.valid) {
            var o = _();

            return o.promise.then(function () {
              t.processCallback(r, n);
            }).catch(function () {
              n.setError();
            }), o.setSuccess(), null;
          }

          if (e) {
            var i = t.cookieStorage.getCookie("kctoken") || e.token,
                a = t.cookieStorage.getCookie("kcrefreshtoken") || e.refreshToken;
            i && a ? (t.setToken(i, a, e.idToken), t.updateToken(-1).then(function () {
              t.onAuthSuccess && t.onAuthSuccess(), n.setSuccess();
            }).catch(function () {
              t.onAuthError && t.onAuthError(), e.onLoad ? t.onLoad(n) : n.setError();
            })) : e.onLoad ? t.onLoad(n) : n.setSuccess();
          } else n.setSuccess();

          return null;
        }), o.catch(function () {
          r.setError();
        }), r.promise;
      }
    }, {
      key: "loadConfig",
      value: function value() {
        var e = this.keycloak,
            t = _();

        if (!this.config.clientId) throw Error("clientId missing");
        if (this.clientId = this.config.clientId, !this.config.realm) throw Error("realm missing");
        return this.authServerUrl = this.config.url, this.realm = this.config.realm, this.endpoints = {
          authorize: function authorize() {
            return "".concat(e.getRealmUrl(), "/protocol/openid-connect/auth");
          },
          token: function token() {
            return "".concat(e.getRealmUrl(), "/protocol/openid-connect/token");
          },
          logout: function logout() {
            return "".concat(e.getRealmUrl(), "/protocol/openid-connect/logout");
          },
          register: function register() {
            return "".concat(e.getRealmUrl(), "/protocol/openid-connect/registrations");
          },
          userinfo: function userinfo() {
            return "".concat(e.getRealmUrl(), "/protocol/openid-connect/userinfo");
          }
        }, t.setSuccess(), t.promise;
      }
    }, {
      key: "onLoad",
      value: function value(e) {
        var t = this,
            r = function r(_r) {
          t.login(_r ? {} : {
            prompt: "none"
          }).then(function () {
            e.setSuccess();
          }).catch(function () {
            e.setError();
          });
        },
            n = function n() {
          var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
              n = t.cookieStorage.getCookie("kctoken"),
              o = t.cookieStorage.getCookie("kcrefreshtoken");
          n || o || !e || r(!0);
        };

        switch (this.initOptions && this.initOptions.onLoad) {
          case "check-login":
            n();
            break;

          case "login-required":
            n(!0);
            break;

          default:
            throw Error("Invalid value for onLoad");
        }
      }
    }, {
      key: "login",
      value: function value() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        return this.adapter.login(e);
      }
    }, {
      key: "getRealmUrl",
      value: function value() {
        if (void 0 !== this.authServerUrl) return "".concat(this.authServerUrl).concat("/" === this.authServerUrl.charAt(this.authServerUrl.length - 1) ? "" : "/", "realms/").concat(encodeURIComponent(this.realm));
      }
    }, {
      key: "parseCallback",
      value: function value(e) {
        var t = this.parseCallbackUrl(e);
        if (!t) return null;
        var r = this.callbackStorage.get(t.state);
        return r && (t.valid = !0, t.redirectUri = r.redirectUri, t.storedNonce = r.nonce, t.prompt = r.prompt, t.pkceCodeVerifier = r.pkceCodeVerifier), t;
      }
    }, {
      key: "parseCallbackUrl",
      value: function value(e) {
        var t;
        this.flow, (t = ["code", "state", "session_state", "kc_action_status"]).push("error"), t.push("error_description"), t.push("error_uri");
        var r,
            n,
            o = e.indexOf("#");
        return "fragment" === this.responseMode && -1 !== o && (r = e.substring(0, o), "" !== (n = function (e, t) {
          for (var r = e.split("&"), n = {
            paramsString: "",
            oauthParams: {}
          }, o = 0; o < r.length; o += 1) {
            var i = r[o].indexOf("="),
                a = r[o].slice(0, i);
            -1 !== t.indexOf(a) ? n.oauthParams[a] = r[o].slice(i + 1) : ("" !== n.paramsString && (n.paramsString += "&"), n.paramsString += r[o]);
          }

          return n;
        }(e.substring(o + 1), t)).paramsString && (r += "#".concat(n.paramsString))), n && n.oauthParams && "standard" === this.flow && (n.oauthParams.code || n.oauthParams.error) && n.oauthParams.state ? (n.oauthParams.newUrl = r, n.oauthParams) : null;
      }
    }, {
      key: "processCallback",
      value: function value(e, t) {
        var r = this,
            n = e.code,
            o = e.error,
            i = e.prompt,
            a = e.kc_action_status,
            s = e.redirectUri,
            c = e.pkceCodeVerifier,
            u = new Date().getTime();
        if (a && this.onActionUpdate && this.onActionUpdate(a), o) {
          if ("none" !== i) {
            var h = {
              error: o,
              error_description: e.error_description
            };
            this.onAuthError && this.onAuthError(h), t && t.setError(h);
          } else t && t.setError(o);
        } else if ("implicit" !== this.flow && n) {
          var l = "code=".concat(n, "&grant_type=authorization_code"),
              f = this.endpoints.token(),
              d = new XMLHttpRequest();
          d.open("POST", f, !0), d.setRequestHeader("Content-type", "application/x-www-form-urlencoded"), l += "&client_id=".concat(encodeURIComponent(this.clientId)), l += "&redirect_uri=".concat(s), c && (l += "&code_verifier=".concat(c)), d.withCredentials = !0;
          d.onreadystatechange = function () {
            if (4 === d.readyState) if (200 === d.status) {
              var n = JSON.parse(d.responseText);
              o = n.access_token, i = n.refresh_token, a = n.id_token, s = "standard" === r.flow, u = (u + new Date().getTime()) / 2, r.setToken(o, i, a, u), r.cookieStorage.addSecureCookie("kctoken", o), r.cookieStorage.addSecureCookie("kcrefreshtoken", i), r.useNonce && (r.tokenParsed && r.tokenParsed.nonce !== e.storedNonce || r.refreshTokenParsed && r.refreshTokenParsed.nonce !== e.storedNonce || r.idTokenParsed && r.idTokenParsed.nonce !== e.storedNonce) ? (r.clearToken(), t && t.setError()) : s && (r.onAuthSuccess && r.onAuthSuccess(), t && t.setSuccess());
            } else r.onAuthError && r.onAuthError(), t && t.setError();
            var o, i, a, s;
          }, d.send(l);
        }
      }
    }, {
      key: "setToken",
      value: function value(e, t, r, n) {
        if (this.tokenTimeoutHandle && (clearTimeout(this.tokenTimeoutHandle), this.tokenTimeoutHandle = null), t ? (this.refreshToken = t, this.refreshTokenParsed = E(t)) : (this.cookieStorage.removeItem("kcrefreshtoken"), delete this.refreshToken, delete this.refreshTokenParsed), r ? (this.idToken = r, this.idTokenParsed = E(r)) : (delete this.idToken, delete this.idTokenParsed), e) {
          if (this.token = e, this.tokenParsed = E(e), this.sessionId = this.tokenParsed.session_state, this.authenticated = !0, this.subject = this.tokenParsed.sub, this.realmAccess = this.tokenParsed.realm_access, this.resourceAccess = this.tokenParsed.resource_access, n && (this.timeSkew = Math.floor(n / 1e3) - this.tokenParsed.iat), null != this.timeSkew && this.onTokenExpired) {
            var o = 1e3 * (this.tokenParsed.exp - new Date().getTime() / 1e3 + this.timeSkew);
            o <= 0 ? this.onTokenExpired() : this.tokenTimeoutHandle = setTimeout(this.onTokenExpired, o);
          }
        } else delete this.token, delete this.tokenParsed, delete this.subject, delete this.realmAccess, delete this.resourceAccess, this.cookieStorage.removeItem("kctoken"), this.authenticated = !1;
      }
    }, {
      key: "isTokenExpired",
      value: function value(e) {
        if (!this.tokenParsed || !this.refreshToken && "implicit" !== this.flow) throw Error("Not authenticated");
        if (null == this.timeSkew) return !0;
        var t = this.tokenParsed.exp - Math.ceil(new Date().getTime() / 1e3) + this.timeSkew;

        if (e) {
          if (Number.isNaN(e)) throw Error("Invalid minValidity");
          t -= e;
        }

        return t < 0;
      }
    }, {
      key: "updateToken",
      value: function value() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 5,
            t = this.keycloak,
            r = _();

        if (!this.refreshToken) return r.setError(), r.promise;

        var n = function n() {
          var n = !1;

          if (-1 === e ? n = !0 : t.tokenParsed && !t.isTokenExpired(e) || (n = !0), n) {
            var o = "grant_type=refresh_token&refresh_token=".concat(t.refreshToken),
                i = t.endpoints.token();

            if (t.refreshQueue.push(r), 1 === t.refreshQueue.length) {
              var a = new XMLHttpRequest();
              a.open("POST", i, !0), a.setRequestHeader("Content-type", "application/x-www-form-urlencoded"), a.withCredentials = !0, o += "&client_id=".concat(encodeURIComponent(t.clientId));
              var s = new Date().getTime();
              a.onreadystatechange = function () {
                if (4 === a.readyState) if (200 === a.status) {
                  s = (s + new Date().getTime()) / 2;
                  var e = JSON.parse(a.responseText);
                  t.setToken(e.access_token, e.refresh_token, e.id_token, s), t.onAuthRefreshSuccess && t.onAuthRefreshSuccess();

                  for (var r = t.refreshQueue.pop(); null != r; r = t.refreshQueue.pop()) {
                    r.setSuccess(!0);
                  }
                } else {
                  console.log("status 400"), 400 === a.status && t.clearToken(), t.onAuthRefreshError && t.onAuthRefreshError();

                  for (var n = t.refreshQueue.pop(); null != n; n = t.refreshQueue.pop()) {
                    n.setError(!0);
                  }
                }
              }, a.send(o);
            }
          } else r.setSuccess(!1);
        };

        return n(), r.promise;
      }
    }, {
      key: "clearToken",
      value: function value() {
        this.token && (this.setToken("", "", ""), this.onAuthLogout && this.onAuthLogout(), this.loginRequired && this.login());
      }
    }, {
      key: "createLoginUrl",
      value: function value(e) {
        var t,
            r,
            n = y(),
            o = y(),
            i = this.adapter.redirectUri(e),
            a = {
          state: n,
          nonce: o,
          redirectUri: encodeURIComponent(i)
        };
        e && e.prompt && (a.prompt = e.prompt), t = e && "register" === e.action ? this.endpoints.register() : this.endpoints.authorize(), r = this.scope ? -1 !== this.scope.indexOf("openid") ? this.scope : "openid ".concat(this.scope) : "openid";
        var s = "".concat(t, "?client_id=").concat(encodeURIComponent(this.clientId), "&redirect_uri=").concat(encodeURIComponent(i), "&state=").concat(encodeURIComponent(n), "&response_mode=").concat(encodeURIComponent(this.responseMode), "&response_type=").concat(encodeURIComponent(this.responseType), "&scope=").concat(encodeURIComponent(r));

        if (this.useNonce && (s += "&nonce=".concat(encodeURIComponent(o))), e && e.prompt && (s += "&prompt=".concat(encodeURIComponent(e.prompt))), e && e.maxAge && (s += "&max_age=".concat(encodeURIComponent(e.maxAge))), e && e.loginHint && (s += "&login_hint=".concat(encodeURIComponent(e.loginHint))), e && e.idpHint && (s += "&kc_idp_hint=".concat(encodeURIComponent(e.idpHint))), e && e.action && "register" !== e.action && (s += "&kc_action=".concat(encodeURIComponent(e.action))), e && e.locale && (s += "&ui_locales=".concat(encodeURIComponent(e.locale))), this.pkceMethod) {
          var c = p(96, "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789");
          a.pkceCodeVerifier = c;

          var u = function (e, t) {
            switch (e) {
              case "S256":
                var r = new Uint8Array(R.sha256.arrayBuffer(t));
                return b.a.fromByteArray(r).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");

              default:
                throw Error("Invalid value for pkceMethod");
            }
          }(this.pkceMethod, c);

          s += "&code_challenge=".concat(u), s += "&code_challenge_method=".concat(this.pkceMethod);
        }

        if (this.callbackStorage.add(a), e.extraQueryParams && Array.isArray(e.extraQueryParams)) {
          var h = new URL(s);
          return e.extraQueryParams.forEach(function (e) {
            e && Array.isArray(e) && h.searchParams.append(e[0], e[1]);
          }), h.toString();
        }

        return s;
      }
    }, {
      key: "logout",
      value: function value() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        return this.adapter.logout(e);
      }
    }, {
      key: "createLogoutUrl",
      value: function value(e) {
        return "".concat(this.endpoints.logout(), "?redirect_uri=").concat(encodeURIComponent(this.adapter.redirectUri(e, !1)));
      }
    }, {
      key: "register",
      value: function value(e) {
        return this.adapter.register(e);
      }
    }, {
      key: "createRegisterUrl",
      value: function value() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        return this.createLoginUrl(Object.assign(Object.assign({}, e), {
          action: "register"
        }));
      }
    }, {
      key: "createAccountUrl",
      value: function value(e) {
        var t,
            r = this.getRealmUrl();
        return void 0 !== r && (t = "".concat(r, "/account?referrer=").concat(encodeURIComponent(this.clientId), "&referrer_uri=").concat(encodeURIComponent(this.adapter.redirectUri(e)))), t;
      }
    }, {
      key: "accountManagement",
      value: function value() {
        return this.adapter.accountManagement();
      }
    }, {
      key: "hasRealmRole",
      value: function value(e) {
        var t = this.realmAccess;
        return !!t && t.roles.indexOf(e) >= 0;
      }
    }, {
      key: "hasResourceRole",
      value: function value(e, t) {
        if (!this.resourceAccess) return !1;
        var r = this.resourceAccess[t || this.clientId];
        return !!r && r.roles.indexOf(e) >= 0;
      }
    }]), e;
  }(),
      x = null,
      T = function T(e) {
    var t = Object(u.useState)(function (e) {
      return x || (x = new C(e)), x;
    }(e)),
        r = c()(t, 1)[0],
        n = Object(u.useState)(""),
        i = c()(n, 2),
        s = i[0],
        h = i[1],
        l = Object(u.useState)(""),
        f = c()(l, 2),
        d = f[0],
        p = f[1],
        y = Object(u.useState)(""),
        v = c()(y, 2),
        m = v[0],
        g = v[1],
        k = e.autoRefreshInterval || 5e3,
        S = function () {
      var e = a()(o.a.mark(function e() {
        return o.a.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (!r.token) {
                  e.next = 4;
                  break;
                }

                if (!r.isTokenExpired(90)) {
                  e.next = 4;
                  break;
                }

                return e.next = 4, r.updateToken(90);

              case 4:
                return e.abrupt("return", r.token);

              case 5:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function () {
        return e.apply(this, arguments);
      };
    }();

    return Object(u.useEffect)(function () {
      if (null !== r) {
        var t = e.scope,
            n = e.onLoad,
            i = void 0 === n ? "check-login" : n,
            c = e.extraQueryParams,
            u = e.redirectUri;
        r.init({
          scope: t,
          onLoad: i,
          token: s,
          refreshToken: m,
          extraQueryParams: c,
          redirectUri: u
        }).then(function (t) {
          t && (h(r.token), r.refreshToken && g(r.refreshToken), r.tokenParsed && p(r.tokenParsed), e.autoRefresh && setInterval(a()(o.a.mark(function e() {
            return o.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.next = 2, S();

                  case 2:
                  case "end":
                    return e.stop();
                }
              }
            }, e);
          })), k));
        }).catch(function (e) {
          console.error("[useKeycloak] Init reject with error:", e);
        });
      }
    }, [r]), {
      authToken: s,
      refreshToken: m,
      tokenParsed: d,
      logout: function logout() {
        null !== r && r.logout();
      },
      login: function login(t, n) {
        r.login({
          scope: e.scope,
          redirectUri: t || "",
          idpHint: n,
          extraQueryParams: e.extraQueryParams
        });
      },
      register: function register(t) {
        r.register({
          scope: e.scope,
          redirectUri: t || "",
          extraQueryParams: e.extraQueryParams
        });
      },
      getRefreshedToken: S,
      isTokenExpired: function isTokenExpired() {
        return r.isTokenExpired(90);
      }
    };
  };
}]);